interface WelcomeScreenProps {
  onEnable: () => void;
  onSkip: () => void;
}

export function WelcomeScreen({ onEnable, onSkip }: WelcomeScreenProps) {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: 'var(--space-4)',
      background: 'var(--color-bg-primary)',
    }}>
      <div style={{
        maxWidth: 420,
        width: '100%',
        textAlign: 'center',
        padding: 'var(--space-8)',
        background: 'var(--color-bg-secondary)',
        borderRadius: 'var(--radius-xl)',
        boxShadow: 'var(--shadow-lg)',
      }}>
        <div style={{ fontSize: 'var(--font-size-3xl)', fontWeight: 'var(--font-weight-bold)', marginBottom: 'var(--space-4)' }}>
          CBM Calculator
        </div>
        <p style={{ fontSize: 'var(--font-size-base)', color: 'var(--color-text-secondary)', marginBottom: 'var(--space-6)' }}>
          Would you like to protect your shipment data with a lock screen? This prevents unauthorized access to your calculations and history.
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-3)' }}>
          <button
            className="btn btn-primary"
            onClick={onEnable}
            style={{ padding: 'var(--space-3) var(--space-4)', fontSize: 'var(--font-size-base)' }}
          >
            Enable App Lock
          </button>
          <button
            className="btn"
            onClick={onSkip}
            style={{ padding: 'var(--space-3) var(--space-4)', fontSize: 'var(--font-size-sm)', color: 'var(--color-text-muted)' }}
          >
            Skip for now
          </button>
        </div>
      </div>
    </div>
  );
}
